import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const PersonBadgeIcon: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 34 34"
    fill="none"
    {...props}
  >
    <path
      d="M34 17C34 7.611 26.389 0 17 0C7.611 0 0 7.611 0 17C0 26.389 7.611 34 17 34C26.389 34 34 26.389 34 17Z"
      fill="white"
    />
    <path
      d="M16.9989 30.805C24.6239 30.805 30.8059 24.624 30.8059 16.998C30.8059 9.373 24.6239 3.19099 16.9989 3.19099C9.37289 3.19099 3.19189 9.373 3.19189 16.998C3.19189 24.624 9.37289 30.805 16.9989 30.805Z"
      fill="#FF612B"
    />
    <path
      d="M23.717 11.535C23.413 11.023 22.749 10.855 22.24 11.158C19.096 13.022 15.05 13.022 11.907 11.158C11.396 10.854 10.733 11.023 10.429 11.535C10.125 12.047 10.295 12.709 10.807 13.012C12.131 13.798 13.584 14.319 15.084 14.568V19.157L12.834 25.138C12.625 25.695 12.907 26.317 13.464 26.527C13.589 26.574 13.717 26.596 13.844 26.596C14.28 26.596 14.69 26.33 14.853 25.897L17.083 19.966L19.109 25.868C19.262 26.315 19.681 26.596 20.129 26.596C20.244 26.596 20.362 26.577 20.479 26.537C21.042 26.344 21.342 25.731 21.149 25.167L19.062 19.087V14.568C20.562 14.319 22.015 13.798 23.339 13.012C23.851 12.709 24.02 12.047 23.717 11.535Z"
      fill="#3D3C38"
    />
    <path
      d="M16.9859 11.881C17.9999 11.881 18.8209 11.06 18.8209 10.046C18.8209 9.03301 17.9999 8.211 16.9859 8.211C15.9719 8.211 15.1509 9.03301 15.1509 10.046C15.1509 11.06 15.9729 11.881 16.9859 11.881Z"
      fill="#3D3C38"
    />
  </Box>
)

export default PersonBadgeIcon
